export function getTranslation(lang: string): {
    googleRating: string;
    seeAllOurReviews: string;
} {

    const translationStrings = {
        en: {
            googleRating: 'GOOGLE RATING',
            seeAllOurReviews: 'See all our reviews'
        },
        es: {
            googleRating: 'CALIFICACIÓN DE GOOGLE',
            seeAllOurReviews: 'Ver todas nuestras reseñas'
        },
    }
    return translationStrings[lang];
}
